import { createElement } from "react";
import { Navigate } from "react-router";
import type { ScreenModule } from "../../../app/screen-module";

/** 旧発注ボード着地 `/app` → ワークスペース一覧へ。 */
function AppHomeRedirect() {
	return createElement(Navigate, { to: "/app/workspace", replace: true });
}

export default {
	id: "end-user.app-home",
	path: "/app",
	area: "end-user",
	label: "ホーム",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: AppHomeRedirect,
} satisfies ScreenModule;
